import Papa from 'papaparse'

import API from '@/api'
import * as types from './mutation-types'

const namespaced = true

const initialState = {
  lastUpdated: null,
  firstSeats: [],
  secondSeats: [],
  topline: [],
  error: null,
  byPartyTab: 'second',
  mapTab: 'first'
};

const mutations = {
  [types.PUT_SEATS](state, { firstSeats, secondSeats }) {
    const firstJson = Papa.parse(firstSeats, {
      header: true
    })
    state.firstSeats = firstJson.data

    const secondJson = Papa.parse(secondSeats, {
      header: true
    })
    state.secondSeats = secondJson.data
  },
  [types.PUT_TOPLINE](state, data) {
    const json = Papa.parse(data, {
      header: true
    })
    state.topline = json.data
  },
  [types.PUT_LAST_UPDATED](state, date) {
    state.lastUpdated = date
  },
  [types.SET_TAB](state, { tabKey, tab }) {
    state[tabKey] = tab
  },
  [types.PUT_ERROR](state, error) {
    state.error = error
  }
};

const actions = {
  getResults: ({ commit }) => {
    const promises = [
      API.get('fpp_seats.csv'),
      API.get('second_vote_by_constituency.csv'),
      API.get('national_party_level.csv')
    ];
    return Promise.all(promises).then(([firstSeats, secondSeats, topline]) => {
      commit(types.PUT_SEATS, { firstSeats, secondSeats })
      commit(types.PUT_TOPLINE, topline)
      const date = new Date().toLocaleString()
      commit(types.PUT_LAST_UPDATED, date)
    })
  },
  setTab: ({ commit }, { tabKey, tab }) => {
    commit(types.SET_TAB, { tabKey, tab })
  }
};

const getters = {
  lastUpdated (state) {
    return state.lastUpdated
  },
  firstSeats (state) {
    return state.firstSeats
  },
  secondSeats (state) {
    return state.secondSeats
  },
  topline (state) {
    return state.topline
  },
  byPartyTab (state) {
    return state.byPartyTab
  },
  mapTab (state) {
    return state.mapTab
  }
};

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
};
